import { BG_SCHEMA, TITLE_SCHEMA, SUBTITLE_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const MATERIALS_ITEM_OPTION = () => ({
  description: 'Descrição',
  link: '',
  media: '',
  title: '',
  visible: false
})

export const MATERIALS_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'materials',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    title: TITLE_SCHEMA('Materiais'),
    subtitle: SUBTITLE_SCHEMA(),
    bg: BG_SCHEMA(),
    'item-color': '#f5f5f5',
    items: [MATERIALS_ITEM_OPTION()],
  }
}

export const beforeParseMaterials = target => {
  commonBeforeParseMethod(target)
}

export const MATERIALS_SECTION = config => ({
  schema: MATERIALS_SCHEMA(config),
  beforeParse: beforeParseMaterials
})
